const dispatchPreloaderComplete = () => {
  ;(window as any).preloaderComplete = true
  window.dispatchEvent(new CustomEvent('preloader:complete'))
}

export const Preloader = () => {
  const preloaderEl = document.getElementById('preloader')
  if (!preloaderEl) {
    // Dispatch event immediately if preloader element doesn't exist
    dispatchPreloaderComplete()
    return
  }

  // Check if preloader was skipped via sessionStorage
  if (preloaderEl.style.display === 'none') {
    // Dispatch event immediately if preloader was hidden
    dispatchPreloaderComplete()
    return
  }

  const el = document.querySelector('.preloader-fg') as HTMLElement
  if (!el) {
    preloaderEl.style.display = 'none'
    dispatchPreloaderComplete()
    return
  }

  // check for images that need to be preloaded, they will have the attribute data-preload-
  const imagesToPreload: NodeListOf<HTMLImageElement> =
    document.querySelectorAll('img[data-preload]')

  const imagePromises: Promise<void>[] = []

  imagesToPreload.forEach((img) => {
    const src = img.getAttribute('data-preload-img')
    if (src) {
      const promise = new Promise<void>((resolve, reject) => {
        const image = new Image()
        image.src = src
        image.onload = () => resolve()
        image.onerror = () => reject()
      })
      imagePromises.push(promise)
    }
  })

  // Start the animation immediately
  let animationComplete = false
  const animation = el.animate(
    [{ transform: 'scaleY(0)' }, { transform: 'scaleY(1)' }],
    {
      duration: 1000,
      easing: 'cubic-bezier(0.77, 0, 0.175, 1)',
      fill: 'forwards',
    },
  )

  animation.onfinish = () => {
    animationComplete = true
  }

  const finishPreloader = () => {
    // If animation hasn't finished yet, wait for it
    if (!animationComplete) {
      animation.finished.then(() => {
        hidePreloader()
      })
    } else {
      hidePreloader()
    }
  }

  const hidePreloader = () => {
    // delay for 300ms
    setTimeout(() => {
      const outroAnimation = preloaderEl.animate(
        [
          { clipPath: 'ellipse(100% 100% at 50% 0%)' },
          { clipPath: 'ellipse(100% 0% at 50% 0%)' },
        ],
        {
          duration: 800,
          easing: 'cubic-bezier(0.77, 0, 0.175, 1)',
          fill: 'forwards',
        },
      )

      outroAnimation.onfinish = () => {
        preloaderEl.style.display = 'none'
        // Dispatch custom event when preloader is complete
        dispatchPreloaderComplete()
      }
    }, 300)
  }

  // Wait for images with a 2 second timeout
  const imageLoadTimeout = new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve()
    }, 2000)
  })

  Promise.race([Promise.all(imagePromises), imageLoadTimeout])
    .then(() => {
      finishPreloader()
    })
    .catch(() => {
      finishPreloader()
    })
}
